import { useFormik } from 'formik';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LuPenLine, LuShare, LuX } from 'react-icons/lu';
import { IoLogOutOutline } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Badge, Box, Button, Checkbox, Flex, Image, Label, Radio, Spinner, Switch, Text, Textarea, useColorMode } from 'theme-ui';
import * as Yup from 'yup';
import { MediaProps, RootState, RoleObj, usersProps } from '../../../@types';
import { UpdateProjectAttachment, editProjectById, getHighlighterByView, getHighlighterByViewSuccess, getProjectById, getProjectByIdSuccess, getSowChecklist, getSowFields, getAllMeetingHistory, createMeetingHistory, updateMeetingHistory } from '../../store/actions/project.action';
import theme from '../../theme';
import { baseUrl } from '../../utils/global';
import { Inputform } from '../forms-component/InputForm';
import FormSelect from '../forms-component/globalSelect';
import FolderNumberDropdown from '../pages/createProject/StepOne/folderNumberDropdown';
import ProjectSideActions from './ProjectSidebar';
import StepTwoOnly from './viewStages';
import StepThreeOnly from './viewTask';
import editIcon from "../../Components/assets/images/edit.svg";
import spent from "../../Components/assets/images/Icon/spent.svg";
import plyBtn from "../../Components/pages/TaskView/playBtn.svg";
import UploadMediaFile from '../UploadMediaFile/UploadMediaFile';
import { useQuery } from '@tanstack/react-query';
import { debounce, get } from 'lodash';
import { ActionOnHold } from '../Actions/ActionModule/ActionOnHold';
import { ActionProjectSetup } from '../Actions/ActionModule/ActionProjectSetup';
import MarkDownParagraph from '../forms-component/MarkDownParagraph';
import { createActionHighlight, removeHighlightFromProject } from '../../store/actions/action.Highlighters';
import { statusColors } from '../../utils/constent';
import GeneralTimerStart from '../pages/TaskView/GeneralTimerModal/GeneralTimerStart';
import { getAllUserWithoutPagination, sentLinkClient } from '../../store/actions/user.action';
import toast from 'react-hot-toast';
import { City, State } from 'country-state-city';
import CircleCounter from './MeetingHistory/CircleCounter';
import 'react-datepicker/dist/react-datepicker.css';
import HistoryEntryModal from './MeetingHistory/HistoryEntryModal';
import { HistoryEntry, CreateMeetingHistoryPayload } from './MeetingHistory/types';
import { HistoryTable } from './MeetingHistory/HistoryTables';
import { getAllClients } from '../../store/actions/masterData.action';

import { getCaPhaseTasks, updateCaPhaseTasks } from '../../store/actions/frontApp.Action';
import { formatMsToHrMin } from '../../utils/GenerateQueryString';
interface DoubleClickModalProps {
    isOpen: boolean;
    toggle: () => void;
    highlight: any;
    colorMode: string;
}

const DoubleClickModal: React.FC<DoubleClickModalProps> = ({ isOpen, toggle, highlight, colorMode }) => {

    const dispatch = useDispatch();
    const { projectId } = useParams<{ projectId: string }>();

    const handleSwitchChange = () => {
        if (highlight?.name) {
            const payload = {

                highlighterName: highlight.name
            }
            dispatch(removeHighlightFromProject(payload, projectId,));
            toggle();
        }
    };
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    return (

        <Modal isOpen={isOpen} toggle={toggle} centered >
            <ModalHeader toggle={toggle} style={{ backgroundColor: modalHeader, color: titleHeader }}>Acknowledgement</ModalHeader>
            <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                <Box><Switch sx={{ position: 'absolute', top: '17px', right: '8px' }} onChange={handleSwitchChange} /></Box>
                <Text sx={{ color: titleHeader }}>Are you sure you want to remove Highlighters?</Text>
            </ModalBody>

        </Modal>
    )
};

const EditModal: React.FC = () => {
    const location = useLocation();
    const { projectId } = useParams<{ projectId: string }>();
    const [colorMode] = useColorMode();
    const { getproject, createprojectMasterData, loader, meetingHistory, historyLoader } = useSelector((state: RootState) => state.project);
    const { caPhaseTasksData, loader: frontAppLoader } = useSelector((state: any) => state.frontApp);
    const { uploadedMedia } = useSelector((state: MediaProps) => state?.media);
    const { userData } = useSelector((state: RootState) => state.user);
    const { clientList } = useSelector((state: RootState) => state.masterData);

    const salesReps = (userData?.data || []).filter((user: usersProps) =>
        user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
    );
    const [description, setDescription] = useState<string>('');
    const [projectStatus, setProjectStatus] = useState<keyof typeof statusColors | "">("");
    const architects = createprojectMasterData?.allArchitect?.data || [];
    const projectManagers = createprojectMasterData?.allProjectManagers || [];
    // const projectWorkers = createprojectMasterData?.allProjectWorkers || [];
    const [highlighters, setHighlighters] = useState<object[]>([]);
    const [isModalOpen, setModalOpen] = useState<boolean>(true);
    const [isDoubleClickModalOpen, setDoubleClickModalOpen] = useState<boolean>(false);
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const [emailOptions, setEmailOptions] = useState<{ label: string; value: string; clientName?: string; clientId?: string }[]>([]);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState<boolean>(false);
    const [tempClientEmail, setTempClientEmail] = useState<string>('');
    const [tempClientEmailId, setTempClientEmailId] = useState<string>('');
    const [tempClientName, setTempClientName] = useState<string>('');
    const [emailModalErrors, setEmailModalErrors] = useState<{ email?: string; name?: string }>({});
    const [emailModalOpenedFrom, setEmailModalOpenedFrom] = useState<'email' | 'name'>('email');
    const [isEmailChanged, setIsEmailChanged] = useState<boolean>(false);
    const params = new URLSearchParams(location.search);
    const [modalOpen, issetModalOpen] = useState<boolean>(false);
    const { auther } = useSelector((state: RootState) => state.auth);
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [isEditing, setIsEditing] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const isFetchingMoreRef = useRef(false);

    // Identify roles for restricting access to Meeting/CA Phase
    // Restricted only if ALL roles are either "Task Manager" or "Task Worker"
    const isRestrictedRole = auther?.Role?.length > 0 && auther?.Role?.every((role: RoleObj) =>
        role.RoleName === "Task Manager" || role.RoleName === "Task Worker"
    );
    const isProjectManager = auther?.Role?.some((role: RoleObj) => role.RoleName === "Project Manager");
    const isSuperAdmin = auther?.Role?.some((role: RoleObj) => role.RoleName === "Super Admin");
    const [isHistoryModalOpen, setHistoryModalOpen] = useState(false);
    const [historyModalType, setHistoryModalType] = useState<'MEETING' | 'CA_PHASE'>('MEETING');
    const [isEditHistory, setIsEditHistory] = useState(false);
    const [selectedEntry, setSelectedEntry] = useState<HistoryEntry | null>(null);
    const [selectedEntryIndex, setSelectedEntryIndex] = useState<number | undefined>(undefined);
    const [pendingCircleIndex, setPendingCircleIndex] = useState<number | null>(null);

    const debouncedDispatch = debounce(
        (fieldName: string, value: unknown, extraPayload: Record<string, unknown> = {}) => {
            dispatch(editProjectById({ [fieldName]: value, ...extraPayload }, projectId, fieldName));
        },
        500
    );
    const debounceRequest = useCallback((fieldName: string, value: unknown, extraPayload?: Record<string, unknown>) => {
        const isValueEmpty = (val: any) => val === "" || val === null || val === undefined || (typeof val === 'string' && val.trim() === "");
        const prevValue = get(getproject, fieldName);
        const isPrevValueEmpty = isValueEmpty(prevValue);
        const isCurrentValueEmpty = isValueEmpty(value);
        if (isPrevValueEmpty && isCurrentValueEmpty) {
            return;
        }
        if (prevValue === value) {
            return;
        }

        debouncedDispatch(fieldName, value, extraPayload)
    }, [debouncedDispatch, getproject])

    const prevClientEmailRef = useRef<string | null>(null);

    useEffect(() => {
        dispatch(getAllClients());
    }, [dispatch]);

    useEffect(() => {
        if (getproject?.clientEmail !== undefined && prevClientEmailRef.current === null) {
            prevClientEmailRef.current = JSON.stringify(getproject.clientEmail);
        }
    }, [getproject?.clientEmail]);

    const handleEmailApiCall = useCallback((emails: string[], extraPayload?: Record<string, unknown>) => {
        const emailStr = JSON.stringify(emails);
        if (emailStr !== prevClientEmailRef.current || extraPayload) {
            prevClientEmailRef.current = emailStr;
            debounceRequest('clientEmail', emails.length > 0 ? emails[0] : '', extraPayload);
        }
    }, [debounceRequest]);

    useEffect(() => {
        const usStates = State.getStatesOfCountry("US");
        setStates(usStates);
        const allStates = State.getStatesOfCountry("US") || [];
        const statesWithCities = allStates.filter((s) => {
            const citiesForState = City.getCitiesOfState("US", s.isoCode) || [];
            return Array.isArray(citiesForState) && citiesForState.length > 0;
        });
        setStates(statesWithCities);
    }, []);

    useEffect(() => {
        return () => {
            debouncedDispatch.cancel()
        }
    }, [])

    useEffect(() => {
        if (getproject.highlighters) {
            setHighlighters(getproject.highlighters)
        }

    }, [getproject.highlighters]);

    useEffect(() => {
        if (getproject?.projectSow?.description) {
            setDescription(getproject?.projectSow?.description || '');
        }
    }, [getproject?.projectSow?.description]);
    useEffect(() => {
        if (getproject?.status) {
            setProjectStatus(getproject?.status as keyof typeof statusColors);
        }
    }, [getproject?.status])

    useEffect(() => {
        const clientEmailOptions = (clientList?.data || []).map((c: { _id?: string; name?: string; email?: string }) => ({
            label: `${c.email || ''}`.trim(),
            value: c.email || '',
            clientName: c.name || '',
            clientId: c._id || ''
        }));

        setEmailOptions(clientEmailOptions);
    }, [clientList]);

    const handleOpenEmailModal = (openedFrom: 'email' | 'name' = 'email') => {
        if (!isSuperAdmin) return;
        setEmailModalOpenedFrom(openedFrom);
        const currentEmail = (Array.isArray(values.clientEmail) && values.clientEmail.length > 0)
            ? values.clientEmail[0]
            : (typeof values.clientEmail === 'string' ? values.clientEmail : '');
        setTempClientEmail(currentEmail || '');
        setTempClientName(values.clientContactPerson || '');
        const rawId = (values as { clientEmailId?: { _id?: string } | string })?.clientEmailId || (getproject as { clientEmailId?: { _id?: string } | string })?.clientEmailId || (typeof getproject?.clientEmail === 'object' ? (getproject?.clientEmail as { _id?: string })?._id : getproject?.clientEmail);
        const resolvedId = typeof rawId === 'object' ? (rawId as { _id?: string })?._id : rawId;
        setTempClientEmailId(resolvedId || '');
        setIsEmailChanged(false);
        setEmailModalErrors({});
        setIsEmailModalOpen(true);
    };

    const handleUpdateClientDetails = () => {
        if (!isSuperAdmin) return;

        const currentEmail = (Array.isArray(values.clientEmail) && values.clientEmail.length > 0)
            ? values.clientEmail[0]
            : (typeof values.clientEmail === 'string' ? values.clientEmail : '');

        const errorsObj: { email?: string; name?: string } = {};
        if (!tempClientEmail?.trim()) {
            errorsObj.email = 'Client Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tempClientEmail.trim())) {
            errorsObj.email = 'Invalid email address';
        }

        if (!tempClientName?.trim()) {
            errorsObj.name = 'Client Name is required';
        }

        if (Object.keys(errorsObj).length > 0) {
            setEmailModalErrors(errorsObj);
            return;
        }

        setEmailModalErrors({});
        const payload: Record<string, any> = {};

        const emailString = tempClientEmail.trim();
        const nameString = tempClientName.trim();

        setFieldValue('clientEmail', [emailString], true);
        payload.clientEmail = emailString;

        setFieldValue('clientContactPerson', nameString, true);
        payload.clientContactPerson = nameString;

        let resolvedClientId = tempClientEmailId;
        if (!resolvedClientId) {
            const matchedClient = (clientList?.data || []).find((c: { _id?: string; name?: string; email?: string }) =>
                c.email?.toLowerCase() === emailString.toLowerCase()
            );
            if (matchedClient?._id) {
                resolvedClientId = matchedClient._id;
            }
        }

        if (resolvedClientId) {
            const idString = typeof resolvedClientId === 'object' ? (resolvedClientId as { _id?: string })?._id : resolvedClientId;
            payload.clientEmailId = idString;
            setFieldValue('clientEmailId', idString, true);
        } else {
            setFieldValue('clientEmailId', '', true);
        }

        dispatch(editProjectById(payload, projectId, 'clientDetails'));
        handleCloseEmailModal();
    };

    const handleCloseEmailModal = () => {
        setIsEmailModalOpen(false);
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleSaveClick = () => {
        debounceRequest('projectSow.description', description);
        setIsEditing(false);

    };
    const handleCancelClick = () => {
        setDescription(getproject?.projectSow?.description || '');
        setIsEditing(false);
    };
    const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDescription(event.target.value);
    };
    const toggleStartTimerModal = () => {
        issetModalOpen(!modalOpen);

    };
    const closeModal = () => {
        if (params.get('isNotification') === 'true') {
            const prevRoute = sessionStorage.getItem('prevRoute');
            if (prevRoute) {
                navigate(prevRoute);
                sessionStorage.removeItem('prevRoute');
            } else {
                navigate('/dashboard');
            }
        } else {
            navigate(-1);
        }
        setModalOpen(false);
    };
    const toggleDoubleClickModal = () => {
        setDoubleClickModalOpen(!isDoubleClickModalOpen);
    };
    useEffect(() => {
        dispatch(getProjectById(projectId));
        dispatch(getHighlighterByView("project"));
        dispatch(getSowChecklist());
        dispatch(getSowFields())
        dispatch(getAllUserWithoutPagination())
        return () => {
            dispatch(getProjectByIdSuccess([]));
            dispatch(getHighlighterByViewSuccess([]));
        }
    }, []);

    useEffect(() => {
        if (uploadedMedia !== null) {
            dispatch(getProjectById(projectId));
        }
    }, [uploadedMedia])


    const validationSchema = Yup.object().shape({
        architect: Yup.string().required('Architect is required'),
        projectManager: Yup.string().required('Project Manager is required'),
        clientEmail: Yup.array().of(
            Yup.string().email('Invalid email address')
        )
    });

    const handleHighlightersUpdate = (data: any) => {
        setHighlighters((prev) => Array.isArray(data) ? [...data] : [])
    }

    const formik = useFormik(

        {
            enableReinitialize: true,
            initialValues: {

                name: getproject?.name || '',
                description: getproject?.projectSow?.description || '',
                architect: (typeof getproject?.architect === 'object' ? (getproject?.architect as { _id?: string })?._id : getproject?.architect) || '',
                projectManager: (typeof getproject?.projectManager === 'object' ? (getproject?.projectManager as { _id?: string })?._id : getproject?.projectManager) || '',
                // projectWorker: getproject?.projectWorker || '',
                folderNumber: getproject?.folderNumber || '',
                quoteNumber: getproject?.quoteNumber || '',
                clientAddress: getproject?.clientAddress || '',
                clientContactPerson: (typeof (getproject as { clientEmailId?: { name?: string; email?: string } | string })?.clientEmailId === 'object' && (getproject as { clientEmailId?: { name?: string; email?: string } }).clientEmailId?.name)
                    ? (getproject as { clientEmailId?: { name?: string; email?: string } }).clientEmailId?.name
                    : (getproject?.clientContactPerson || ''),
                clientEmail: ((typeof (getproject as { clientEmailId?: { name?: string; email?: string } | string })?.clientEmailId === 'object' && (getproject as { clientEmailId?: { name?: string; email?: string } }).clientEmailId?.email)
                    ? [(getproject as { clientEmailId?: { name?: string; email?: string } }).clientEmailId?.email]
                    : (Array.isArray(getproject?.clientEmail)
                        ? getproject?.clientEmail
                        : (getproject?.clientEmail ? [getproject?.clientEmail] : [])))
                    .map((item: any) => typeof item === 'string' ? item.trim() : item)
                    .filter((item: any) => item !== ''),
                stateName: getproject?.stateName || '',
                cityName: getproject?.cityName || '',
                salesRepresentative: (getproject?.salesRepresentative && typeof getproject.salesRepresentative === 'object' ? getproject.salesRepresentative._id : (getproject?.salesRepresentative || '')),
                siteVisitPin: getproject?.siteVisitPin || '',
                "Project #": getproject?.projectSow?.fields?.["Project #"],
                tmQuote: getproject?.tmQuote,
                "Spec Documents?": getproject?.projectSow?.fields?.["Spec Documents?"],
                outOfState: getproject?.highlighters?.some(highlighter => highlighter.name === "Out of State") || false,
                Meetings: getproject?.meetings || 0,
                "CA Phase": getproject?.totalTimeTracked || 0,
                isMEP: getproject?.isMEP || false,
                isStructural: getproject?.isStructural || false,
                isFireSprinkler: getproject?.isFireSprinkler || false,
            },

            onSubmit: () => { }
        }
    );
    const { handleSubmit, setFieldValue, handleBlur, touched, values, errors } = formik;

    const handleSseChange = (data: { [key: string]: any }) => {
        Object.keys(data)?.forEach((element: string) => {

            if (element === "highlighters") {
                handleHighlightersUpdate(data[element]);
            }
            if (element === "status") {
                setProjectStatus(data[element] as keyof typeof statusColors);
            }
            if (element === "projectSow.description") {
                setDescription(data[element]);
            }
            if (element === "clientEmail") {
                const emailVal = data[element];
                const emailArray = Array.isArray(emailVal) ? emailVal : (emailVal ? [emailVal] : []);
                formik.setFieldValue(element, emailArray, true);
            } else if ((element === "salesRepresentative" || element === "architect" || element === "projectManager") && data[element] && typeof data[element] === 'object') {
                formik.setFieldValue(`${element}`, data[element]._id || "", true);
            } else {
                formik.setFieldValue(`${element}`, data[element] || "", true);
            }
        });

    }

    const handleCheckboxChange = (event: any) => {
        const isOutOfStatePresent = getproject.highlighters.some(highlighter => highlighter.name === "Out of State");

        const isChecked = isOutOfStatePresent ? false : true;
        dispatch(createActionHighlight({
            actionType: "Out of State",
            projectId: projectId,
            isChecked: isChecked
        }));
        setFieldValue("outOfState", event.target.checked);
    };

    const { data: eventSource } = useQuery({
        queryKey: ['projectSSE', projectId],
        queryFn: () => {
            const eventSource = new EventSource(`${baseUrl}sse/${projectId}`);
            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    handleSseChange(data);
                    dispatch(UpdateProjectAttachment(data.attachments))
                } catch (error) {
                    console.error('Error parsing SSE data:', error);
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE Error:', error);
                eventSource.close();
            };
            return eventSource;
        },
        refetchInterval: 60000
    })
    useEffect(() => {
        return () => {
            eventSource?.close();
        };
    }, [])
    useEffect(() => {
        const selectedStateName = values.stateName;

        if (!selectedStateName) {
            setCities([]);
            setFieldValue("cityName", "");
            return;
        }

        // 🔑 Find ISO code from state name
        const matchedState = states.find(
            (s) => s.name === selectedStateName
        );

        if (!matchedState) {
            setCities([]);
            setFieldValue("cityName", "");
            return;
        }

        const stateCode = matchedState.isoCode;

        const stateCities = City.getCitiesOfState("US", stateCode);
        setCities(stateCities);
    }, [values.stateName, states]);

    const [selectedLinkEmails, setSelectedLinkEmails] = useState<string[]>([]);
    const [sendResetPasswordLinkEmail, setSendResetPasswordLinkEmail] = useState<boolean>(false);
    const [sendProjectAssignmentEmail, setSendProjectAssignmentEmail] = useState<boolean>(false);

    const openModal = () => {
        const emails = Array.isArray(values.clientEmail) ? values.clientEmail : (values.clientEmail ? [values.clientEmail] : []);
        if (emails.length > 0) {
            setSelectedLinkEmails([emails[0]]);
            setSendResetPasswordLinkEmail(false);
            setSendProjectAssignmentEmail(false);
            setShowConfirmation(true);
        }
        else {
            toast.error("Please Enter email!")
        }
    }
    const confirmLinkSent = () => {
        if (selectedLinkEmails.length === 0) {
            toast.error("Please select at least one email.");
            return;
        }
        if (!sendResetPasswordLinkEmail && !sendProjectAssignmentEmail) {
            toast.error("Please select at least one option (Send Credentials or View Project).");
            return;
        }
        const cleanedEmails = selectedLinkEmails.map(email => typeof email === 'string' ? email.replace(/\s+/g, '') : email);
        dispatch(sentLinkClient(projectId, {
            clientEmails: cleanedEmails,
            sendResetPasswordLinkEmail,
            sendProjectAssignmentEmail
        }))
        setShowConfirmation(false);
    }
    const cancelConfirmation = () => {
        setSendResetPasswordLinkEmail(false);
        setSendProjectAssignmentEmail(false);
        setShowConfirmation(false);
    };

    const handleHistorySave = (type: 'MEETING' | 'CA_PHASE') => {
        const isMeeting = type === 'MEETING';
        const isEdit = isEditHistory;
        const indexToUpdate = pendingCircleIndex;

        if (selectedEntry) {
            if (!isMeeting) {
                // CA_PHASE Edit
                let payload: Partial<HistoryEntry> = {};
                const originalEntry = (Array.isArray(caPhaseTasksData?.data?.data) ? caPhaseTasksData.data.data : caPhaseTasksData.data || []).find((h: HistoryEntry) => h._id === selectedEntry?._id);
                if (originalEntry) {
                    if (selectedEntry.status !== originalEntry.status) payload.status = selectedEntry.status;
                    if (selectedEntry.stampedAs !== originalEntry.stampedAs) payload.stampedAs = selectedEntry.stampedAs;
                    if (selectedEntry.cmt_subject !== originalEntry.cmt_subject) payload.cmt_subject = selectedEntry.cmt_subject;

                    const originalCompletedAt = originalEntry.closeDueDate ? originalEntry.closeDueDate.split('T')[0] : '';
                    const selectedCompletedAt = selectedEntry.closeDueDate ? selectedEntry.closeDueDate.split('T')[0] : '';
                    if (selectedCompletedAt !== originalCompletedAt) {
                        (payload).closeDueDate = selectedCompletedAt;
                    }
                    if (JSON.stringify(selectedEntry.attachment) !== JSON.stringify(originalEntry.attachment)) {
                        payload.attachment = selectedEntry.attachment;
                    }
                }

                if (Object.keys(payload).length > 0) {
                    setIsHistorySaving(true);
                    dispatch(updateCaPhaseTasks(projectId, selectedEntry._id, payload, (updateSuccess: boolean) => {
                        setIsHistorySaving(false);
                        if (updateSuccess !== false) {
                            setHistoryModalOpen(false);
                        }
                    }, true));
                } else {
                    setHistoryModalOpen(false);
                }
                return;
            }

            let payload: Partial<HistoryEntry> = {};

            if (isEdit) {
                const originalEntry = meetingHistory.find(h => h._id === selectedEntry?._id);
                if (originalEntry) {
                    if (selectedEntry.description !== originalEntry.description) payload.description = selectedEntry.description;
                    if (selectedEntry.meetingLink !== originalEntry.meetingLink) payload.meetingLink = selectedEntry.meetingLink;
                    if (selectedEntry.meetingNotes !== originalEntry.meetingNotes) payload.meetingNotes = selectedEntry.meetingNotes;

                    const originalDate = originalEntry.meetingDate ? (originalEntry.meetingDate instanceof Date ? originalEntry.meetingDate : new Date(originalEntry.meetingDate)).toISOString().split('T')[0] : '';
                    const selectedDate = selectedEntry.meetingDate ? (selectedEntry.meetingDate instanceof Date ? selectedEntry.meetingDate : new Date(selectedEntry.meetingDate)).toISOString().split('T')[0] : '';

                    if (selectedDate !== originalDate) {
                        payload.meetingDate = selectedDate.replace(/-/g, '/');
                    }

                    if (pendingCircleIndex !== null && pendingCircleIndex !== (originalEntry.meetings || 0)) {
                        payload.meetings = pendingCircleIndex;
                    }
                }

                const callback = () => {
                    setIsHistorySaving(false);
                    if (indexToUpdate !== null) {
                        setFieldValue('Meetings', indexToUpdate);
                    }
                    setPendingCircleIndex(null);
                    setHistoryModalOpen(false);
                    setSelectedTabIndex(3);
                };

                if (Object.keys(payload).length > 0) {
                    setIsHistorySaving(true);
                    dispatch(updateMeetingHistory(selectedEntry?._id, payload, type, projectId, callback));
                } else {
                    setHistoryModalOpen(false);
                }
            } else {
                const createPayload: CreateMeetingHistoryPayload = {
                    projectId: projectId || '',
                    description: selectedEntry.description,
                    meetingLink: selectedEntry.meetingLink,
                    meetingNotes: selectedEntry.meetingNotes,
                    meetings: (pendingCircleIndex || 0),
                    meetingDate: selectedEntry.meetingDate
                        ? (selectedEntry.meetingDate instanceof Date
                            ? selectedEntry.meetingDate.toISOString().split('T')[0].replace(/-/g, '/')
                            : selectedEntry.meetingDate.split('T')[0].replace(/-/g, '/'))
                        : new Date().toISOString().split('T')[0].replace(/-/g, '/'),
                    type: type
                };
                setIsHistorySaving(true);
                dispatch(createMeetingHistory(createPayload, () => {
                    setIsHistorySaving(false);
                    if (indexToUpdate !== null) {
                        setFieldValue('Meetings', indexToUpdate);
                    }
                    setPendingCircleIndex(null);
                    setHistoryModalOpen(false);
                    setSelectedTabIndex(3);
                }));
            }
        }
    };

    const handleScrollBottom = () => {
        if (!caPhaseTasksData?.data?.pagination) return;
        const { hasNextPage, page } = caPhaseTasksData.data.pagination;

        if (hasNextPage && !isFetchingMoreRef.current) {
            isFetchingMoreRef.current = true;
            setIsFetchingMore(true);
            dispatch(getCaPhaseTasks(projectId, page + 1, 15, (success: boolean) => {
                isFetchingMoreRef.current = false;
                setIsFetchingMore(false);
            }, true)); // isSilent = true so we don't show full page loader
        }
    };

    // implement Highlight
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [isHistorySaving, setIsHistorySaving] = useState(false);
    const [Open, setOpen] = useState(false);
    const [selectedHighlight, setSelectedHighlight] = useState<any>(null);
    const [highlight, setHighlight] = useState<any>(null);

    const isHistoryModified = useMemo(() => {
        if (!isEditHistory || !selectedEntry) return true;

        if (historyModalType === 'CA_PHASE') {
            const originalEntry = (Array.isArray(caPhaseTasksData?.data) ? caPhaseTasksData.data : (Array.isArray(caPhaseTasksData) ? caPhaseTasksData : [])).find((h: HistoryEntry) => h._id === selectedEntry._id);
            if (!originalEntry) return true;

            if (selectedEntry.status !== originalEntry.status) return true;
            if (selectedEntry.stampedAs !== originalEntry.stampedAs) return true;
            if (selectedEntry.cmt_subject !== originalEntry.cmt_subject) return true;

            const originalCompletedAt = originalEntry.closeDueDate ? originalEntry.closeDueDate.split('T')[0] : '';
            const selectedCompletedAt = selectedEntry.closeDueDate ? selectedEntry.closeDueDate.split('T')[0] : '';
            if (selectedCompletedAt !== originalCompletedAt) return true;

            if (JSON.stringify(selectedEntry.attachment || []) !== JSON.stringify(originalEntry.attachment || [])) return true;

            return false;
        }

        const originalEntry = meetingHistory.find(h => h._id === selectedEntry._id);
        if (!originalEntry) return true;

        let modified = false;
        if (selectedEntry.description !== originalEntry.description) modified = true;
        if (selectedEntry.meetingLink !== originalEntry.meetingLink) modified = true;
        if (selectedEntry.meetingNotes !== originalEntry.meetingNotes) modified = true;

        let originalDate = '';
        let selectedDate = '';
        try {
            originalDate = originalEntry.meetingDate ? (originalEntry.meetingDate instanceof Date ? originalEntry.meetingDate : new Date(originalEntry.meetingDate)).toISOString().split('T')[0] : '';
            selectedDate = selectedEntry.meetingDate ? (selectedEntry.meetingDate instanceof Date ? selectedEntry.meetingDate : new Date(selectedEntry.meetingDate)).toISOString().split('T')[0] : '';
        } catch (e) { }

        if (selectedDate !== originalDate) modified = true;
        if (pendingCircleIndex !== null && pendingCircleIndex !== (originalEntry.meetings || 0)) modified = true;

        return modified;
    }, [isEditHistory, selectedEntry, historyModalType, meetingHistory, caPhaseTasksData, pendingCircleIndex]);

    const handleHighlightClick = (highlight: any) => {
        if (clickTimeoutRef?.current) {
            clearTimeout(clickTimeoutRef?.current);
            clickTimeoutRef.current = null;
            const dblclickHighlights = ['Background Change Done', 'New Info Added', 'Revision', 'Plan Check', 'Need Info', 'Internal Review', 'Hour a Day',
                'Blocked By Trade', 'Todo Per Review', 'Blocked by Info', 'Final Review', 'Delivery Notes', 'Ready To Deliver', ' Deliver', 'Project Setup', 'Blocked By Trade Completed', 'Background Change InProgress', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM', 'Waiting for Trade', 'Background Change']
            setHighlight(dblclickHighlights?.includes(highlight?.name) ? { ...highlight } : highlight);
            setDoubleClickModalOpen(true);

        }
        else {
            clickTimeoutRef.current = setTimeout(() => {
                clickTimeoutRef.current = null;
                const backgroundChangeGroups = ["On Hold", "Project Setup"];
                setSelectedHighlight(backgroundChangeGroups?.includes(highlight?.name) ? { ...highlight } : highlight);
                setOpen(true);
            }, 300);
        }

    };
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={cancelConfirmation}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const label = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const cursorPointerGroups = ["On Hold", "Project Setup", "Hour a Day", "Internal Review", 'Todo Per Review', 'Blocked by Info', "Delivery Notes", 'Ready To Deliver', ' Deliver', "Blocked By Trade", 'Blocked By Trade Completed', ' Waiting for Payment - FULL', ' Waiting for Payment - PRELIM', 'Waiting for Trade', "Need Info", "New Info Added", "Final Review", "Plan Check", "Revision", "Background Change", "Background Change Done", "Background Change InProgress",];

    const renderTabs = () => (
        <Tabs className='p-3' selectedIndex={selectedTabIndex} onSelect={(index) => {
            setSelectedTabIndex(index);
            if (index === 3) {
                dispatch(getAllMeetingHistory(projectId, 'MEETING'));
            } else if (index === 4) {
                dispatch(getCaPhaseTasks(projectId));
            }
        }}>
            <TabList>
                <Tab>Details</Tab>
                <Tab>Stages Lists</Tab>
                <Tab>Tasks Lists</Tab>
                <Tab>Meetings</Tab>
                <Tab>CA Phase</Tab>
            </TabList>
            <TabPanel>
                <UploadMediaFile mediaData={getproject?.attachments || []} typeId={{
                    project_id: projectId || '',
                }} type="project" loader={loader} id={projectId} />
            </TabPanel>
            <TabPanel>
                <StepTwoOnly projectId={projectId ? projectId : ""} />
            </TabPanel>
            <TabPanel>
                <StepThreeOnly projectId={projectId || ''} />
            </TabPanel>
            <TabPanel>
                <HistoryTable
                    type="MEETING"
                    data={meetingHistory}
                    loader={historyLoader}
                    isReadOnly={isRestrictedRole}
                    onEdit={(meeting: HistoryEntry, index?: number) => {
                        setSelectedEntry(meeting);
                        setSelectedEntryIndex(index);
                        setIsEditHistory(true);
                        setHistoryModalType('MEETING');
                        setHistoryModalOpen(true);
                    }}
                />
            </TabPanel>
            <TabPanel>
                <HistoryTable
                    type="CA_PHASE"
                    data={Array.isArray(caPhaseTasksData?.data?.data) ? caPhaseTasksData.data.data : (Array.isArray(caPhaseTasksData?.data) ? caPhaseTasksData.data : (Array.isArray(caPhaseTasksData) ? caPhaseTasksData : []))}
                    loader={frontAppLoader || isFetchingMore}
                    isReadOnly={!isProjectManager}
                    onScrollBottom={handleScrollBottom}
                    onEdit={(phase: HistoryEntry, index?: number) => {
                        setSelectedEntry(phase);
                        setSelectedEntryIndex(index);
                        setIsEditHistory(true);
                        setHistoryModalType('CA_PHASE');
                        setHistoryModalOpen(true);
                    }}
                />
            </TabPanel>
        </Tabs>
    );

    const initialEmail = (Array.isArray(values.clientEmail) && values.clientEmail.length > 0)
        ? values.clientEmail[0]
        : (typeof values.clientEmail === 'string' ? values.clientEmail : '');
    const initialName = values.clientContactPerson || '';
    const isFormChanged = tempClientEmail.trim() !== initialEmail.trim() || tempClientName.trim() !== initialName.trim();

    return (
        <>
            <Modal isOpen={isModalOpen} toggle={closeModal} scrollable centered style={{ maxWidth: "93%", border: 'none' }}>
                <ModalHeader className='d-table' style={{ backgroundColor: modalHeader, color: titleHeader }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', }}>
                        <h4 style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', color: titleHeader }}>
                            {getproject?.name} &nbsp;
                            {highlighters?.map((badge: any) => (
                                <Badge
                                    key={badge?._id}
                                    color={badge?.color}
                                    sx={{
                                        backgroundColor: 'transparent',
                                        borderRadius: "8px",
                                        gap: '3px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: `1px solid ${badge?.color}`,
                                        cursor: `${cursorPointerGroups.includes(badge.name) ? "pointer" : "default"}`
                                    }}
                                    onClick={(e: any) => {
                                        handleHighlightClick(badge);
                                    }}
                                >
                                    {badge?.icon && <Image
                                        title={badge.name}
                                        src={badge?.icon}
                                        alt={badge?.name}
                                        width={14}
                                        height={14}
                                    />}
                                    <Text sx={{ color: `${badge?.color}` }}>{badge?.name}</Text>
                                </Badge>
                            ))}

                        </h4>

                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                            {getproject?.status !== 'Draft' && (
                                <Button variant="startButton" sx={{ background: modalHeader }} onClick={toggleStartTimerModal}>
                                    <img src={spent} alt="" /> Start Tracking <img src={plyBtn} alt="" />
                                </Button>
                            )}

                            {loader && <Spinner size={30} className='mx-2' />}
                            <LuX onClick={closeModal} style={{ cursor: 'pointer', marginLeft: 'auto' }} />
                            <LuShare
                                size={24}
                                style={{ cursor: "pointer", color: "#8d8d8d", marginLeft: '10px' }}
                                onClick={openModal}
                                title="Share"
                            />
                        </div>

                    </div>
                    <Box >
                        <Badge
                            sx={{
                                backgroundColor: `${statusColors[projectStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`}`,
                                border: `1px solid ${statusColors[projectStatus as keyof typeof statusColors] || `${theme?.colors?.muted}`}`, borderRadius: '8px',
                                padding: '4px 8px',
                                color: '',
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}
                        >
                            {projectStatus}
                        </Badge>

                        {getproject?.trelloId && <a target='_blank' href={`https://trello.com/c/${getproject?.trelloId}`} style={{
                            position: 'absolute',
                            right: "20px",
                            width: "150px",
                            background: "#7743db",
                            color: "#ffffff",
                            textDecoration: "none",
                            padding: "5px",
                            borderRadius: "5px",
                            textAlign: "center",
                            fontSize: "large"
                        }}>{"Go to Trello"}<IoLogOutOutline className='ms-2 fs-3' /></a>}
                    </Box>
                    <GeneralTimerStart isOpen={modalOpen} toggle={toggleStartTimerModal} autherId={auther?._id} projectId={projectId} />

                </ModalHeader>

                <ModalBody className='p-0' style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Flex sx={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        <div className='col-md-8' >
                            <Box className="p-3">
                                <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Text variant="SelectLabel" sx={{ color: label }} >Description</Text>
                                    {!isEditing && colorMode === 'light' ? (
                                        <Image
                                            src={editIcon}
                                            sx={{ cursor: 'pointer', width: '24px', height: '24px' }}
                                            onClick={handleEditClick}
                                        />
                                    ) : <LuPenLine style={{ cursor: 'pointer', width: '24px', height: '24px', color: 'white' }} onClick={handleEditClick} />}
                                </Flex>
                                {isEditing ? (
                                    <>
                                        <Textarea
                                            value={description}
                                            onChange={handleTextareaChange}
                                            rows={description.length > 30 ? 10 : 2}
                                            placeholder="Description..."
                                        />
                                        <Flex className="mt-3" sx={{ justifyContent: 'end', gap: '8px' }}>
                                            <Button
                                                sx={{
                                                    background: 'white',
                                                    color: theme?.colors?.primary,
                                                    border: '1px solid',
                                                    textAlign: 'center',
                                                    borderRadius: '12px',
                                                }}
                                                onClick={handleCancelClick}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                sx={{ background: theme?.colors?.primary, textAlign: 'center', borderRadius: '12px' }}
                                                onClick={handleSaveClick}
                                            >
                                                Save
                                            </Button>
                                        </Flex>
                                    </>
                                ) : (

                                    <Box className='ps-2' sx={{ minHeight: `${description.length < 30 ? "72px" : "265px"}`, maxHeight: '400px', border: `2px solid ${theme?.colors?.lightbackground}`, overflowY: "auto", borderRadius: "4px", resize: 'vertical' }}>

                                        <MarkDownParagraph markdown={description} />
                                    </Box>
                                )}

                            </Box>
                            <Box className='p-3 mt-2' sx={{ display: ['block', 'grid', 'grid'], gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'], columnGap: 3, rowGap: 2 }}>
                                <Box >
                                    <Inputform
                                        sx={{ color: label }}
                                        label={"Name"}
                                        Placeholder={"Project Name..."}
                                        Name={"name"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.name}
                                        errors={errors?.name}
                                        values={values.name}
                                        Max_Length={10}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                            debounceRequest('name', event.target.value.trim());
                                        }}
                                        onKeyDown={(event: any) => {
                                            if (event.key === 'Enter') {
                                                handleBlur(event);
                                                debounceRequest('name', event.target.value.trim());
                                            }
                                        }}
                                        OnChange={(event: any) => {
                                            const newName = event.target.value;
                                            setFieldValue("name", newName, true);
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <FormSelect
                                        sx={{ color: label }}
                                        label={"Architect"}
                                        placeholder='Select Architect'
                                        value={typeof values?.architect === 'object' ? (values?.architect as { _id?: string })?._id : values?.architect}
                                        options={architects.map((architect) => ({
                                            label: architect?.name,
                                            value: architect?._id
                                        })) || []}
                                        touched={touched?.architect}
                                        errors={errors?.architect}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                        }}
                                        Name='architect'
                                        styles={{ color: "#000" }}
                                        onChange={(selectedArchitect: any) => {
                                            setFieldValue("architect", selectedArchitect?.value, true);
                                            debounceRequest('architect', selectedArchitect?.value);

                                        }} />
                                </Box>
                                <Box>
                                    <FormSelect
                                        sx={{ color: label }}
                                        label={"Project Manager"}
                                        value={
                                            projectManagers.some((x: { _id: string }) => x._id === (typeof values?.projectManager === 'object' ? (values?.projectManager as { _id?: string })?._id : values?.projectManager))
                                                ? (typeof values?.projectManager === 'object' ? (values?.projectManager as { _id?: string })?._id : values?.projectManager)
                                                : null
                                        }
                                        placeholder={"Select Project Manager"}
                                        options={projectManagers.map((projectManager) => ({
                                            label: `${projectManager?.FirstName} ${projectManager?.LastName}`,
                                            value: projectManager?._id
                                        })) || []}
                                        isMulti={false}
                                        DefultSelect='Select PM'
                                        touched={touched?.projectManager}
                                        errors={errors?.projectManager}
                                        onBlur={handleBlur}
                                        Name='projectManager'
                                        onChange={(selectedManager: { value: string } | null) => {
                                            setFieldValue("projectManager", selectedManager?.value, true);
                                            debounceRequest('projectManager', selectedManager?.value);
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <FormSelect
                                        sx={{ color: label }}
                                        label={"Sales Representative"}
                                        value={
                                            salesReps.some((r: usersProps) => r._id === (typeof values?.salesRepresentative === 'object' ? (values?.salesRepresentative as unknown as usersProps)?._id : values?.salesRepresentative))
                                                ? (typeof values?.salesRepresentative === 'object' ? (values?.salesRepresentative as unknown as usersProps)?._id : values?.salesRepresentative)
                                                : null
                                        }
                                        placeholder={"Select Sales Representative"}
                                        options={salesReps.map((salesRep: usersProps) => ({
                                            label: `${salesRep?.FirstName} ${salesRep?.LastName}`,
                                            value: salesRep?._id
                                        })) || []}
                                        isMulti={false}
                                        DefultSelect='Select Sales Representative'
                                        touched={touched?.salesRepresentative}
                                        errors={errors?.salesRepresentative}
                                        onBlur={handleBlur}
                                        Name='salesRepresentative'
                                        asterisk={true}
                                        onChange={(selected: { value: string }) => {
                                            setFieldValue("salesRepresentative", selected?.value, true);
                                            debounceRequest('salesRepresentative', selected?.value);
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <FolderNumberDropdown
                                        sx={{ color: label }}
                                        label={"Folder Number"}
                                        value={values?.folderNumber}
                                        touched={touched?.folderNumber}
                                        errors={errors?.folderNumber}
                                        onBlur={handleBlur}
                                        onChange={(selectedFolderNumber: any) => {
                                            setFieldValue("folderNumber", selectedFolderNumber, true);
                                            if (!loader) {
                                                debounceRequest('folderNumber', selectedFolderNumber);
                                            }
                                        }}

                                        disable={false}
                                    />
                                </Box>
                                <Box>
                                    <Inputform
                                        // mb={4}
                                        sx={{ color: label }}
                                        label={"Quote Number"}
                                        Placeholder={"Quote Number"}
                                        Name={"quoteNumber"}
                                        type='number'
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.quoteNumber}
                                        errors={errors?.quoteNumber}
                                        values={values.quoteNumber}
                                        Max_Length={10}
                                        onKeyDown={(event: any) => {
                                            if (event.key === 'Enter') {
                                                handleBlur(event);
                                                debounceRequest('quoteNumber', event.target.value);
                                            }
                                        }}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                            debounceRequest('quoteNumber', event.target.value);
                                        }}
                                        OnChange={(event: any) => {
                                            const newQuote = event.target.value;
                                            setFieldValue("quoteNumber", newQuote, true);
                                        }}
                                    />
                                </Box>
                                <Box >
                                    <Inputform
                                        sx={{ color: label }}
                                        label={"Client Address"}
                                        Placeholder={"Enter Address..."}
                                        Name={"clientAddress"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.clientAddress}
                                        errors={errors?.clientAddress}
                                        values={values.clientAddress}
                                        Max_Length={10}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                            debounceRequest('clientAddress', event.target.value.trim());
                                        }}
                                        onKeyDown={(event: any) => {
                                            if (event.key === 'Enter') {
                                                handleBlur(event);
                                                debounceRequest('clientAddress', event.target.value.trim());
                                            }
                                        }}
                                        OnChange={(event: any) => {
                                            const newName = event.target.value;
                                            setFieldValue("clientAddress", newName, true);
                                        }}
                                    />
                                </Box>
                                <Box
                                    title={!isSuperAdmin ? "Only Super Admin can edit" : ((Array.isArray(values.clientEmail) && values.clientEmail.length > 0) ? values.clientEmail[0] : '')}
                                >
                                    <Inputform
                                        sx={{ color: label, cursor: isSuperAdmin ? 'pointer' : 'not-allowed', '&:disabled': { opacity: 0.6, cursor: 'not-allowed', backgroundColor: 'transparent' } }}
                                        label="Client Email"
                                        Placeholder={isSuperAdmin ? "Click to edit client email..." : "Client email..."}
                                        Name="clientEmail"
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.clientEmail}
                                        errors={errors?.clientEmail}
                                        values={(Array.isArray(values.clientEmail) && values.clientEmail.length > 0) ? values.clientEmail[0] : ''}
                                        disabled={!isSuperAdmin}
                                        readOnly={true}
                                        asterisk={true}
                                        onClick={isSuperAdmin ? () => handleOpenEmailModal('email') : undefined}
                                        endIcon={isSuperAdmin ? <LuPenLine style={{ fontSize: '15px', color: label }} /> : undefined}
                                    />
                                </Box>
                                <Box
                                    title={!isSuperAdmin ? "Only Super Admin can edit" : (values.clientContactPerson || '')}
                                >
                                    <Inputform
                                        sx={{ color: label, cursor: isSuperAdmin ? 'pointer' : 'not-allowed', '&:disabled': { opacity: 0.6, cursor: 'not-allowed', backgroundColor: 'transparent' } }}
                                        label={"Client Name"}
                                        Placeholder={isSuperAdmin ? "Click to edit client name..." : "Enter Contact..."}
                                        Name={"clientContactPerson"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.clientContactPerson}
                                        errors={errors?.clientContactPerson}
                                        values={values.clientContactPerson}
                                        disabled={!isSuperAdmin}
                                        readOnly={true}
                                        asterisk={true}
                                        onClick={isSuperAdmin ? () => handleOpenEmailModal('name') : undefined}
                                        endIcon={isSuperAdmin ? <LuPenLine style={{ fontSize: '15px', color: label }} /> : undefined}
                                    />
                                </Box>
                                <Box >
                                    <FormSelect
                                        label={"State Name"}
                                        value={values?.stateName}
                                        placeholder={"Select State Name"}
                                        options={states.map((state) => ({
                                            label: state?.name,
                                            value: state?.name
                                        })) || []}
                                        isMulti={false}
                                        sx={{ color: colorMode === "light" ? "#0a0a0a" : "#dadada" }}
                                        DefultSelect='Select state name'
                                        touched={touched?.stateName}
                                        errors={errors?.stateName}
                                        onBlur={handleBlur}
                                        Name='stateName'
                                        asterisk={true}
                                        onChange={(v: { value: string; label: string } | null) => {
                                            setFieldValue("stateName", v?.value, true);
                                            setFieldValue("cityName", "", true);
                                            setCities([])
                                        }}

                                    />
                                </Box>
                                <Box >
                                    <FormSelect
                                        label={"City Name"}
                                        value={values?.cityName}
                                        placeholder={"Select City Name"}
                                        options={cities.map((city) => ({
                                            label: city?.name,
                                            value: city?.name
                                        })) || []}
                                        isMulti={false}
                                        sx={{ color: colorMode === "light" ? "#0a0a0a" : "#dadada" }}
                                        DefultSelect='Select city name'
                                        touched={touched?.cityName}
                                        errors={errors?.cityName}
                                        onBlur={handleBlur}
                                        Name='cityName'
                                        asterisk={true}
                                        onChange={(v: { value: string; label: string } | null) => {
                                            setFieldValue("cityName", v?.value, true);
                                            debounceRequest('cityName', v?.value, { stateName: values?.stateName });

                                        }}
                                    />
                                </Box>
                                <Box >
                                    <Inputform
                                        sx={{ color: label }}
                                        label={"Project #"}
                                        Placeholder={"Project #..."}
                                        Name={"Project #"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.["Project #"]}
                                        errors={errors?.["Project #"]}
                                        values={values?.["Project #"]}
                                        // Max_Length={10}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                            debounceRequest('projectSow.fields.Project #', event.target.value);
                                        }}
                                        onKeyDown={(event: any) => {
                                            if (event.key === 'Enter') {
                                                handleBlur(event);
                                                debounceRequest('projectSow.fields.Project #', event.target.value);
                                            }
                                        }}
                                        OnChange={(event: any) => {
                                            const newName = event.target.value;
                                            setFieldValue("Project #", newName, true);
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Inputform
                                        sx={{ color: label }}
                                        label={"Site Visit PIN"}
                                        Placeholder={"Enter Site Visit PIN"}
                                        Name={"siteVisitPin"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.siteVisitPin}
                                        errors={errors?.siteVisitPin}
                                        values={values.siteVisitPin}
                                        onBlur={(event: any) => {
                                            handleBlur(event);
                                            debounceRequest('siteVisitPin', event.target.value.trim());
                                        }}
                                        onKeyDown={(event: any) => {
                                            if (event.key === 'Enter') {
                                                handleBlur(event);
                                                debounceRequest('siteVisitPin', event.target.value.trim());
                                            }
                                        }}
                                        OnChange={(event: any) => {
                                            setFieldValue("siteVisitPin", event.target.value, true);
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Inputform
                                        sx={{ color: label }}
                                        label={"Out of State"}
                                        type='checkbox'
                                        Placeholder={"Enter Out of State"}
                                        Name={"outOfState"}
                                        Title_sx={{ color: "grey3" }}
                                        touched={touched?.outOfState}
                                        errors={errors?.outOfState}
                                        values={values.outOfState}
                                        OnChange={handleCheckboxChange}
                                    />
                                </Box>
                                <Box>
                                    <CircleCounter
                                        label="Meetings:"
                                        disabled={loader || isRestrictedRole}
                                        value={values.Meetings || 0}
                                        total={4}
                                        onChange={(val) => {
                                            if (val === 0) {
                                                debounceRequest('meetings', 0);
                                            } else {
                                                setFieldValue("Meetings", val);
                                            }
                                        }}
                                        onCircleClick={(index: number) => {
                                            const currentValue = values.Meetings || 0;
                                            if (index <= currentValue) return;

                                            setPendingCircleIndex(index);
                                            setIsEditHistory(false);
                                            setHistoryModalType('MEETING');
                                            setSelectedEntry({ _id: '', description: '', meetingDate: new Date() });
                                            setHistoryModalOpen(true);
                                        }}
                                        onDisabledClick={() => toast.error("Restricted for this role")}
                                        labelSx={{ color: label }}
                                    />
                                    <Box sx={{ mt: 2 }}>
                                        <Text variant="SelectLabel" sx={{ color: label }}>
                                            CA Phase Time Spent : {(() => {
                                                const ms = values["CA Phase"] || 0;
                                                return formatMsToHrMin(ms);
                                            })()}
                                        </Text>
                                    </Box>
                                </Box>
                                <Box sx={{ alignItems: 'center' }}>
                                    <Text variant='SelectLabel' sx={{ color: label, lineHeight: 1.2, fontWeight: 600, mb: 2 }}>Spec Documents?</Text>
                                    <Box sx={{ display: 'flex', mt: 2 }}>
                                        <Label>
                                            <Radio
                                                name='Spec Documents?'
                                                value='true'
                                                checked={values?.["Spec Documents?"] === true}
                                                onChange={() => {
                                                    setFieldValue('Spec Documents?', true);
                                                    debounceRequest('projectSow.fields.Spec Documents?', true);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            Yes
                                        </Label>
                                        <Label>
                                            <Radio
                                                name='Spec Documents?'
                                                value='false'
                                                checked={values?.["Spec Documents?"] === false}
                                                onChange={() => {
                                                    setFieldValue('Spec Documents?', false);
                                                    debounceRequest('projectSow.fields.Spec Documents?', false);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            No
                                        </Label>
                                    </Box>
                                </Box>
                                <Box sx={{ alignItems: 'center' }}>
                                    <Text variant='SelectLabel' sx={{ color: label, lineHeight: 1.2, fontWeight: 600, mb: 2 }}>T&M Quote</Text>
                                    <Box sx={{ display: 'flex', mt: 1 }}>
                                        <Label>
                                            <Radio
                                                name='tmquote'
                                                value='true'
                                                checked={values.tmQuote === true}
                                                onChange={() => {
                                                    setFieldValue('tmQuote', true);
                                                    debounceRequest('tmQuote', true);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            Yes
                                        </Label>
                                        <Label>
                                            <Radio
                                                name='tmquote'
                                                value='false'
                                                checked={values.tmQuote === false}
                                                onChange={() => {
                                                    setFieldValue('tmQuote', false);
                                                    debounceRequest('tmQuote', false);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            No
                                        </Label>
                                    </Box>
                                    {touched.tmQuote && errors.tmQuote && <p className='text-danger'>{errors.tmQuote}</p>}
                                </Box>
                                <Box sx={{ alignItems: 'center', gridColumn: '1 / -1' }}>
                                    <Text variant='SelectLabel' sx={{ color: label, lineHeight: 1.2, fontWeight: 600, mb: 2 }}>Type of Project :</Text>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'nowrap', gap: 3 }}>
                                        <Label sx={{ color: label, cursor: 'default', userSelect: 'none', width: 'auto', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Checkbox
                                                checked={getproject?.isMEP || false}
                                                disabled
                                                onChange={() => { }}
                                            />
                                            MEP
                                        </Label>
                                        <Label sx={{ color: label, cursor: 'default', userSelect: 'none', width: 'auto', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Checkbox
                                                checked={getproject?.isStructural || false}
                                                disabled
                                                onChange={() => { }}
                                            />
                                            Structural
                                        </Label>
                                        <Label sx={{ color: label, cursor: 'default', userSelect: 'none', width: 'auto', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Checkbox
                                                checked={getproject?.isFireSprinkler || false}
                                                disabled
                                                onChange={() => { }}
                                            />
                                            Fire Sprinkler
                                        </Label>
                                    </Box>
                                </Box>
                            </Box>
                            {(selectedTabIndex < 3) && (
                                <Box>
                                    {renderTabs()}
                                </Box>
                            )}
                        </div>
                        <ProjectSideActions isTracking={null} elapsedTime={"00:00:00"} timeTaken={undefined} projectId={projectId} />
                    </Flex>

                    {(selectedTabIndex === 3 || selectedTabIndex === 4) && (
                        <Box sx={{ width: '100%', mt: 3 }}>
                            {renderTabs()}
                        </Box>
                    )}
                </ModalBody>
            </Modal>
            {selectedHighlight?.name === "On Hold" && (
                <ActionOnHold selectedHighlight={selectedHighlight} Open={Open} setOpen={setOpen} actionObject={{ projectId: projectId }} />
            )}
            {selectedHighlight?.name === "Project Setup" && (
                <ActionProjectSetup selectedHighlight={selectedHighlight} Open={Open} setOpen={setOpen} actionObject={{ projectId: projectId }} />
            )}
            <Modal isOpen={isEmailModalOpen} toggle={handleCloseEmailModal} centered style={{ color: titleHeader }}>
                <ModalHeader toggle={handleCloseEmailModal} style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    Edit Client Details
                </ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Box mb={2}>
                        <FormSelect
                            sx={{ color: label }}
                            label="Client Email"
                            asterisk={true}
                            touched={!!emailModalErrors.email}
                            errors={emailModalErrors.email}
                            isCreatable={true}
                            value={tempClientEmail || null}
                            placeholder="Select or enter client email..."
                            options={emailOptions}
                            isMulti={false}
                            DefultSelect="Select client email..."
                            Name="tempClientEmail"
                            isValidNewOption={(inputValue: string, selectValue: unknown, selectOptions: readonly { label: string; value: string }[]) => {
                                if (!inputValue || !inputValue.trim()) return false;
                                const lowerInput = inputValue.trim().toLowerCase();
                                const hasMatch = selectOptions.some((opt: { label: string; value: string }) =>
                                    opt.value.toLowerCase().includes(lowerInput) ||
                                    opt.label.toLowerCase().includes(lowerInput)
                                );
                                return !hasMatch;
                            }}
                            onFocus={() => {
                                setTempClientEmail('');
                                setTempClientEmailId('');
                            }}
                            onChange={(newValue: { label: string; value: string; clientName?: string; clientId?: string } | null) => {
                                setEmailModalErrors(prev => ({ ...prev, email: undefined }));
                                setIsEmailChanged(true);
                                if (!newValue) {
                                    setTempClientEmail('');
                                    setTempClientEmailId('');
                                    return;
                                }

                                const selectedEmail = newValue.value;
                                const matchedOption = emailOptions.find(opt => opt.value.toLowerCase() === selectedEmail.toLowerCase());

                                if (matchedOption) {
                                    setTempClientEmail(matchedOption.value);
                                    setTempClientEmailId(matchedOption.clientId || '');
                                    setTempClientName(matchedOption.clientName || '');
                                    if (matchedOption.clientName) {
                                        setEmailModalErrors(prev => ({ ...prev, name: undefined }));
                                    }
                                } else {
                                    setTempClientEmail(selectedEmail);
                                    setTempClientEmailId('');
                                }
                            }}
                        />
                    </Box>
                    <Box mb={2}>
                        <Inputform
                            sx={{ color: label }}
                            label="Client Name"
                            asterisk={true}
                            touched={!!emailModalErrors.name}
                            errors={emailModalErrors.name}
                            Placeholder="Enter Client Name..."
                            Name="tempClientName"
                            Title_sx={{ color: "grey3" }}
                            values={tempClientName}
                            OnChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setEmailModalErrors(prev => ({ ...prev, name: undefined }));
                                setTempClientName(event.target.value);
                            }}
                        />
                    </Box>
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Button variant="secondary" onClick={handleCloseEmailModal} style={{ marginRight: '8px' }}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleUpdateClientDetails}
                        disabled={!tempClientEmail || !tempClientEmail.trim() || !tempClientName || !tempClientName.trim() || !isFormChanged}
                        sx={{
                            '&:disabled': {
                                opacity: 0.5,
                                cursor: 'not-allowed',
                                pointerEvents: 'auto'
                            }
                        }}
                    >
                        Update
                    </Button>
                </ModalFooter>
            </Modal>
            <DoubleClickModal isOpen={isDoubleClickModalOpen} toggle={toggleDoubleClickModal} highlight={highlight} colorMode={colorMode} />
            <Modal isOpen={showConfirmation} toggle={cancelConfirmation} size="md" centered>
                <ModalHeader close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>Confirm Sent Link</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <p style={{ marginBottom: '10px' }}>Are you sure you want to send link to client?</p>

                    <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px', borderRadius: '4px' }}>
                        {Array.isArray(values.clientEmail) ? values.clientEmail.map((email: string, index: number) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                <input
                                    type="checkbox"
                                    id={`email-checkbox-${index}`}
                                    checked={selectedLinkEmails.includes(email)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedLinkEmails([...selectedLinkEmails, email]);
                                        } else {
                                            setSelectedLinkEmails(selectedLinkEmails.filter(e => e !== email));
                                        }
                                    }}
                                    style={{ marginRight: '8px', cursor: 'pointer' }}
                                />
                                <label htmlFor={`email-checkbox-${index}`} style={{ cursor: 'pointer', margin: 0, fontSize: '14px' }}>
                                    {email}
                                </label>
                            </div>
                        )) : null}
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                id="send-credentials-checkbox"
                                checked={sendResetPasswordLinkEmail}
                                onChange={(e) => setSendResetPasswordLinkEmail(e.target.checked)}
                                style={{ marginRight: '8px', cursor: 'pointer' }}
                            />
                            <label htmlFor="send-credentials-checkbox" style={{ cursor: 'pointer', margin: 0, fontSize: '14px' }}>
                                Send Credentials
                            </label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                id="view-project-checkbox"
                                checked={sendProjectAssignmentEmail}
                                onChange={(e) => setSendProjectAssignmentEmail(e.target.checked)}
                                style={{ marginRight: '8px', cursor: 'pointer' }}
                            />
                            <label htmlFor="view-project-checkbox" style={{ cursor: 'pointer', margin: 0, fontSize: '14px' }}>
                                Project Assignment
                            </label>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: 'pointer' }} onClick={cancelConfirmation}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: 'pointer' }} onClick={confirmLinkSent}>Yes</Button>
                </ModalFooter>
            </Modal>


            {/* Entry Modals */}
            <HistoryEntryModal
                isOpen={isHistoryModalOpen}
                toggle={() => setHistoryModalOpen(false)}
                onSave={() => handleHistorySave(historyModalType)}
                type={historyModalType}
                isEdit={isEditHistory}
                selectedEntry={selectedEntry}
                setSelectedEntry={setSelectedEntry}
                modalHeader={modalHeader}
                titleHeader={titleHeader}
                isLoading={isHistorySaving}
                disableSave={!isHistoryModified}
                isRestricted={historyModalType === 'CA_PHASE' ? !auther?.Role?.some((role: RoleObj) => role.RoleName === "Project Manager") : isRestrictedRole}
                entryIndex={selectedEntryIndex}
            />
        </>
    );
};

export default EditModal;